import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from 'react';
import dict from '@/i18n/translations';

const LanguageContext = createContext(null);

const STORAGE_KEY = 'pv_locale';

export const LanguageProvider = ({ children }) => {
  const [locale, setLocaleState] = useState(() => {
    if (typeof window === 'undefined') return 'it';
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'it' || saved === 'en') return saved;
    // Default: Italian for first-time visitors (Prime Vision is an Italian product)
    return 'it';
  });

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const setLocale = useCallback((next) => {
    if (next !== 'it' && next !== 'en') return;
    setLocaleState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch (_) {}
  }, []);

  const value = useMemo(() => ({
    locale,
    setLocale,
    t: dict[locale],
  }), [locale, setLocale]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
